import { Slot } from '../c-mp/comp/Slot'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { endOf } from '../fun/endOf'
import { formatDate } from '../fun/formatDate'
import { formatNumber } from '../fun/formatNumber'
import { getAge } from '../fun/getAge'
import { _ } from '../model/ccc'
import type { IPerson } from '../model/IPerson'
import { PortraitComp } from './PortraitComp'

export const PortraitButtonComp = defineComponent<{
	getPerson: () => IPerson
	getFileName: () => string
	getSelectedFileName: () => string | undefined
	setSelectedFileName: (value: string) => void
}>(
	'PortraitButtonComp',
	({ getPerson, getFileName, getSelectedFileName, setSelectedFileName }, $) => {
		return (
			<button
				class={() => [
					_.ccc_button__person,
					getSelectedFileName() === getFileName() && _.ccc__selected,
				]}
				onclick={() => {
					setSelectedFileName(getFileName())
				}}
			>
				<PortraitComp getPerson={getPerson} getFileName={getFileName} />{' '}
				<div>
					<Slot get={() => formatDate(getFileName().slice(0, 4))} />
					<div class={_.ccc_date}>
						<b>
							<Slot
								get={() =>
									formatNumber(
										getAge(
											getPerson().birthDate,
											endOf(getFileName().replace(/\..*/, '')),
										),
									) ?? '?'
								}
							/>{' '}
							éves
						</b>
					</div>
				</div>
			</button>
		)
	},
)
